/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Table, Button, notification, DatePicker, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import branchService from 'services/branch.service';
import { formatDateForClient, formatDateForServer, formatMoney } from 'helpers/utils';
import download from 'js-file-download';
import { storage } from 'helpers';
import 'antd/dist/reset.css';

const { RangePicker } = DatePicker;
const { Option } = Select;

class Payment extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],
      branches: [],
      selectedBranch: '0',
      loading: false,
      startDate: formatDateForClient(dayjs().subtract(365, 'days')),
      endDate: formatDateForClient(),
      currentMerch: context?.selectedMerch,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Takip Numarası</div>,
          dataIndex: 'Invoice',
          key: 'Invoice',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div style={{ textAlign: 'center' }}>
              <span className="table-title-calibri-bold-12">{row.TakipNo}</span>
              <br />
              <span className="table-content-calibri-light-12">
                İlişkili Fatura: {row.RelatedInvoiceNumber}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Şube Bilgisi</div>,
          // 'Şube - Merkez / Şube No / Şube Adı',
          dataIndex: 'Branch',
          key: 'Branch',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">
                {row.BranchName ? row.BranchName : ''} - {row.BranchId ? row.BranchId : ''}
              </span>
              <br />
              <span className="table-content-calibri-light-11">
                {' '}
                {row.SubeOrMerkez ? row.SubeOrMerkez : ''}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">İlişkili Fatura Tutarı</div>,
          dataIndex: 'Invoice',
          key: 'Invoice',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">
                {row.RelatedInvoiceAmount ? `${formatMoney(row.RelatedInvoiceAmount)} TL` : ''}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Kesinti Tutarı</div>,
          dataIndex: 'DeductionAmount',
          key: 'DeductionAmount',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">{`${formatMoney(row.DeductionAmount)} TL`}</span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Banka</div>,
          dataIndex: 'Bank',
          key: 'Bank',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">{row.Bank ? row.Bank : ''} </span>
              <br />
              <span className="table-content-calibri-light-11">
                {' '}
                {row.BankIBAN ? row.BankIBAN : ''}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tarihi / Durumu</div>,
          dataIndex: 'PaymentStatus',
          key: 'PaymentStatus',
          width: 150,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">
                {row.PaymentStatus ? row.PaymentStatus : ''}{' '}
              </span>
              <br />
              <span className="table-content-calibri-light-12">
                {' '}
                {row.Date ? dayjs(row.Date).format('DD.MM.YYYY') : ''}
              </span>
            </div>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Ödeme Tutarı</div>,
          dataIndex: 'PaymentAmount',
          key: 'PaymentAmount',
          width: 200,
          align: 'center',
          render: (text, row) => (
            <div className="text-align-center">
              <span className="table-title-calibri-bold-12">
                {row.PaymentAmount ? `${formatMoney(row.PaymentAmount)} TL` : ''}
              </span>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getReports();
    this.getCurrentMerchBranches();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getReports();
      this.getCurrentMerchBranches();
    }
  }

  getReports = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, endDate, startDate, selectedBranch } = this.state;
        if (currentMerch?.number) {
          const { payload } = await reportService.getPaymentReports(
            currentMerch?.number,
            formatDateForServer(startDate),
            formatDateForServer(endDate),
            selectedBranch,
          );
          this.setState({ loading: false, reports: payload });
        }
      } catch (error) {
        this.setState({ loading: false, reports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  onDateChange = (dates) => {
    if (!dates || dates.length !== 2) return;
    const startDate = formatDateForClient(dates[0]);
    const endDate = formatDateForClient(dates[1]);
    this.setState({ startDate, endDate }, () => {
      storage.set({ startDate, endDate }, 'date-filters');
      this.getReports();
    });
  };

  getCurrentMerchBranches = async () => {
    try {
      this.setState({ loading: true, currentMerch: this.context?.selectedMerch });
      const number = this.context?.selectedMerch?.number;
      if (number) {
        const { payload } = await branchService.getBranchesByMerch(number);
        this.setState({ loading: false, branches: payload });
      }
    } catch (error) {
      this.setState({ loading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  onBranchChange = (selectedBranch) => {
    if (!selectedBranch) {
      // eslint-disable-next-line no-param-reassign
      selectedBranch = 0;
    }
    this.setState({ selectedBranch }, () => {
      storage.set({ selectedBranch }, 'branch-filters');
      this.getReports();
    });
  };

  renderBranchOptions = () => {
    const { branches } = this.state;
    return branches?.map((branch) => (
      <Option key={branch.BranchId} value={branch.BranchId}>
        {branch.BranchTitle}
      </Option>
    ));
  };

  downloadExcel = async () => {
    try {
      this.setState({ downloading: true });
      const { currentMerch, startDate, endDate, selectedBranch } = this.state;
      const data = await reportService.getPaymentReportsExcel(
        currentMerch?.number,
        formatDateForServer(startDate),
        formatDateForServer(endDate),
        selectedBranch,
      );
      download(data, `Odemelerim-${currentMerch?.number}-${dayjs().format('DD-MM-YYYY')}.xls`);
      this.setState({ downloading: false });
    } catch (error) {
      this.setState({ loading: false, downloading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  render() {
    const { reports, columns, loading, startDate, endDate, downloading } = this.state;
    return (
      <PageContainer
        title="Ödemeler"
        extra={[
          <RangePicker
            allowClear={false}
            defaultValue={[dayjs(startDate, 'DD.MM.YYYY'), dayjs(endDate, 'DD.MM.YYYY')]}
            key="eod"
            onChange={this.onDateChange}
            format="DD.MM.YYYY"
          />,
          <Select
            key="branch"
            loading={loading}
            defaultValue={null}
            onChange={this.onBranchChange}
            style={{ width: 200 }}
          >
            <Option value={null} key="ALL">
              Tüm Şubeler
            </Option>
            {this.renderBranchOptions()}
          </Select>,
          <Button
            loading={downloading}
            disabled={loading || downloading}
            key="download"
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => {
              this.downloadExcel();
            }}
          >
            İndir
          </Button>,
        ]}
      >
        <Table
          loading={loading}
          dataSource={reports}
          columns={columns}
          pagination={false}
          rowKey={(index) => index}
        />
      </PageContainer>
    );
  }
}

Payment.contextType = AuthContext;

const PaymentWrapper = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  return <Payment {...props} navigate={navigate} params={params} />;
};

export default PaymentWrapper;
